






























































































































































































import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import PrettyCheck from 'pretty-checkbox-vue/check';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import useEcho from '@/useEcho';
import quiz from '@/table/quiz';

import {
  getLive,
  getQuiz,
  getQuizzes,
  deleteQuiz,
  controlQuiz,
  deleteQuizzes,
  getLeaderboards,
  resetLeaderboards,
  downloadLeaderboardAsCSV,
} from '@/api';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithVoteDisplay from '@/components/Live/CommonModalWithVoteDisplay.vue';

const List = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonModalWithVoteDisplay,
  },
  setup() {
    const { pusher } = useEcho();
    const { route, routerPersist, router } = useRouter(['searchString']);
    const toCommaFormat = (string: string | number, min = 0, max = 2) => parseFloat(string as string || '0').toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });
    const activeQuizId = ref(-1);
    const loading = ref(true);
    const quizzes = ref([]);
    const activeQuiz: Ref<any> = ref({
      id: -1,
      choices: [],
    });
    const pagination = ref({
      // eslint-disable-next-line
      current_page: 1,
      total: 0,
    });
    const page = ref(1);
    const sort = ref({ field: 'created_at', order: 'ASC' });
    const searchString = ref('');

    const callGetLive = async () => {
      loading.value = true;
      activeQuizId.value = (await getLive(route.value.params.liveId)).active_quiz_id;
    };
    const callGetQuizzes = async () => {
      loading.value = true;
      const { data, ...paginatorData } = await getQuizzes(
        route.value.params.liveId,
        page.value,
        30,
        sort.value,
        searchString.value,
      );
      quizzes.value = data.map((elm: any) => ({ // TODO: rewrite transformer function
        ...elm,
        _secondaryControls: false,
        _playPauseControls: elm.id !== activeQuizId.value,
      }));
      pagination.value = paginatorData;
      loading.value = false;
    };

    const leaderboards = ref([]);
    const callGetLeaderboards = async () => {
      const { data, ...paginatorData } = await getLeaderboards();
      leaderboards.value = data;
    };
    const clearLeaderboard = async () => {
      loading.value = true;
      const result = await resetLeaderboards(route.value.params.liveId);
      if (result.status === 200) leaderboards.value = [];
      loading.value = false;
    };

    const pendingSearch = _.debounce(async () => {
      page.value = 1;
      await callGetQuizzes();
    }, 500);

    onMounted(async () => {
      await callGetLive();
      await callGetLeaderboards();
      await callGetQuizzes();
      if (pusher) {
        const channel = pusher.subscribe(`session.${route.value.params.liveId}`);
        channel.bind('LeaderboardUpdated', async (data: any) => {
          if (data.quizChoices[0].quiz_id === activeQuizId.value) activeQuiz.value = await getQuiz(activeQuizId.value);
        });
      }
    });

    onUnmounted(() => {
      pusher.unsubscribe(`session.${route.value.params.liveId}`);
    });

    watch(() => page.value, async (newVal) => {
      // eslint-disable-next-line
      if (newVal !== pagination.value.current_page) {
        await callGetQuizzes();
      }
    });
    const handleSortChange = (sortParam: { field: string; order: string }) => {
      sort.value = sortParam;
    };
    watch(() => sort.value, async (newVal, oldVal) => {
      // eslint-disable-next-line
      if (newVal !== oldVal) {
        await callGetQuizzes();
      }
    });

    // ==================== //
    // Use with select item //
    const selectedItems: number[] = reactive([]);
    const selectItem = (id: number, status: boolean) => {
      if (status) {
        const removeIndex = selectedItems.findIndex((elm: any) => elm === id);
        if (removeIndex > -1) selectedItems.splice(removeIndex, 1);
      } else {
        selectedItems.push(id);
      }
      const index = quizzes.value.findIndex((elm: any) => elm.id === id);
      (quizzes.value[index] as any)._secondaryControls = !status;
    };
    const selectAllItems = () => {
      if (selectedItems.length > 0) selectedItems.splice(0, selectedItems.length);
      quizzes.value.forEach((elm: any, index: number) => {
        (quizzes.value[index] as any)._secondaryControls = true;
        selectedItems.push(elm.id);
      });
    };
    const unselectAllItems = () => {
      selectedItems.splice(0, selectedItems.length);
      quizzes.value.forEach((elm: any, index: number) => {
        (quizzes.value[index] as any)._secondaryControls = false;
      });
    };

    // =========================== //
    // Use with play pause control //
    const playPauseAction = async (id: number | null) => {
      let submitId: number | null = id;
      if (activeQuizId.value === id) {
        submitId = null;
      }
      activeQuizId.value = await controlQuiz(route.value.params.liveId, submitId as any);
      await callGetQuizzes();
    };

    // Delete fn
    const deleteItemModal = ref(null);
    const deleteItemsModal = ref(null);
    const openDeleteItemModal = (item: any) => {
      (deleteItemModal.value as any).compose({
        id: item.id,
        action: 'ลบ',
        entity: 'คำถาม',
        body: `เป็นการลบ<br>${item.name}<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้`,
      });
    };
    const deleteItemAction = async (id: number) => {
      const result = await deleteQuiz(id);
      await callGetQuizzes();
    };
    const deleteItemsAction = async () => {
      const result = await deleteQuizzes(selectedItems);
      await callGetQuizzes();
    };

    async function downloadReport(quizId?: number) {
      await downloadLeaderboardAsCSV(route.value.params.liveId, quizId);
    }

    const singleQuiz: Ref<any> = ref({
      id: -1,
      choices: [],
    });
    const modalWithQuizDisplay = ref(null);
    async function pendingToViewResult(quizId: number) {
      if (quizId === activeQuizId.value) {
        singleQuiz.value = activeQuiz.value;
      } else {
        singleQuiz.value = await getQuiz(quizId);
      }
      (modalWithQuizDisplay.value as any).open();
    }
    watch(() => activeQuizId.value, async (newVal, oldVal) => {
      if (newVal > -1 && newVal !== oldVal && newVal !== null) {
        activeQuiz.value = await getQuiz(activeQuizId.value);
      }
    });
    const totalSubmittedDisplayQuiz = computed(() => {
      if (activeQuiz.value.id === -1) return 0;
      let result = 0;
      activeQuiz.value.choices.forEach((choice: any) => {
        result += choice.count;
      });
      if (result === 0) return 1;
      return result;
    });

    function getTotalQuizAnswerInRecord(selectedQuiz: any) {
      let result = 0;
      // eslint-disable-next-line
      selectedQuiz.choices?.forEach((choice: any) => {
        result += choice.count;
      });
      return result;
    }

    return {
      toCommaFormat,
      quizzes,
      leaderboards,
      quizTableOptions: quiz,
      activeQuizId,
      page,
      pagination,
      loading,
      searchString,

      pendingSearch,

      sort,
      handleSortChange,

      playPauseAction,

      selectItem,
      selectAllItems,
      selectedItems,
      unselectAllItems,

      openDeleteItemModal,
      deleteItemAction,
      deleteItemsAction,
      deleteItemModal,
      deleteItemsModal,

      downloadReport,
      clearLeaderboard,

      singleQuiz,
      activeQuiz,
      modalWithQuizDisplay,
      pendingToViewResult,
      totalSubmittedDisplayQuiz,

      getTotalQuizAnswerInRecord,
    };
  },
});

export default List;
